import React from 'react';
import PropTypes from 'prop-types';
import { tagPropTypes } from 'constants/propTypes';
import { classNameWithModifiers as withMods } from 'helpers/class-name';
import Message from 'components/Message';

const Tag = ({ tag, ...restProps }) => {
  const { id, name, subtags = [] } = tag;
  const { activeTagIds, onChange, isDisabled } = restProps;
  const checked = activeTagIds[id] || false;
  const disabled = isDisabled(tag);
  const key = `tag-${id}`;
  return (
    <li key={key} className="tag">
      <label htmlFor={key} className={withMods('tag__label', { disabled })}>
        <input
          type="checkbox"
          id={key}
          className="tag__input"
          checked={checked}
          disabled={disabled}
          onChange={onChange.bind(null, tag)}
        />
        <Message message={name} />
      </label>

      {subtags.length > 0 && checked && (
        <ul className="tag__subtags">
          {subtags.map(subtag => (
            <Tag key={subtag.id} tag={subtag} {...restProps} />
          ))}
        </ul>
      )}
    </li>
  );
};

Tag.propTypes = {
  tag: tagPropTypes,
  // TODO(ralph): Figure out how to remove the string proptype from this definition
  activeTagIds: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.string]),
  onChange: PropTypes.func,
  isDisabled: PropTypes.func,
};

export default Tag;
